export default {
    shared: {
        storedPlaceholder: 'Stored; type to replace',
    },
    // Sub-tabs of the website's Module settings tab.
    tabs: {
        checkout: 'Checkout',
        customer: 'Customer',
        vehicleLookup: 'Vehicle lookup',
        vehicleStock: 'Vehicle stock',
    },
    modules: {
        introSuper: 'Enable optional features for this website. A module stays inactive until all its dependencies are also on.',
        intro: 'Modules enabled for this website. Contact us to add more.',
        partlyOnNote: 'Partly on, the parts below say which.',
        partlyOn: 'Partly on',
        alsoEnables: 'Turning this on also enables {modules}.',
        requires: 'requires {modules}',
        inactiveDeps: 'Inactive, turn on {modules} first.',
        addOns: 'Add-ons',
        // Keyed by module id as the registry sends it. Brand names (google,
        // meta, bol) are left out: the server's label is shown as is.
        names: {
            abandoned_cart: 'Abandoned cart emails',
            blog: 'Blog',
            cart: 'Shopping cart',
            catalog: 'Product catalog',
            catalog_discount: 'Catalog & volume discounts',
            checkout: 'Checkout',
            customer: 'Customer accounts',
            delivery_slot: 'Delivery moments',
            discount: 'Discounts',
            faq: 'FAQ',
            giftcard: 'Gift cards',
            landingpages: 'Landing pages',
            newsletter: 'Newsletter',
            portfolio: 'Portfolio',
            review_request: 'Review requests',
            seo: 'SEO',
            shipping: 'Shipping & carriers',
            tax: 'VAT engine',
            vehicle_lookup: 'Vehicle lookup',
            vehicle_stock: 'Vehicle stock',
        },
        // Keyed by group id (cms-core ModuleGroup).
        groups: {
            ecommerce: {
                label: 'Webshop',
                description: 'Product catalog, cart and checkout. Turning this on also enables customer accounts, which checkout needs.',
            },
            discounts: {
                label: 'Discounts',
                description: 'Voucher codes at checkout, gift cards sold in the shop, and automatic sale or volume pricing in the catalog.',
            },
        },
    },
    google: {
        analytics: {
            title: 'Google Analytics and Tag Manager',
            intro: "Loaded on every page, only after the visitor allows it on the cookie banner: Analytics needs statistics consent, Tag Manager either kind, and Google's Consent Mode tells the tags which was given. The shop's e-commerce events (product views, cart, checkout, purchase) go to both.",
            ga4: 'GA4 measurement ID',
            gtm: 'Tag Manager container ID',
            oneOfTwo: 'Fill in one of the two. With Tag Manager, set up GA4 inside the container instead of here, or every visit is counted twice.',
        },
        server: {
            title: 'Purchases sent from the server',
            intro: 'A payment that settles after the customer left (a bank transfer still pending, a closed tab) never shows them the thank-you page, so the tags never see the purchase. With an API secret, the shop sends those purchases to GA4 itself, ten minutes after the payment, for visitors who allowed statistics cookies. GA4 counts each order once, from the page or from the server. Needs the GA4 measurement ID above.',
            apiSecret: 'Measurement Protocol API secret',
            apiSecretPlaceholder: 'GA4 Admin, Data streams, your stream, Measurement Protocol API secrets',
            removeSecret: 'Remove the stored secret',
        },
        verification: {
            title: 'Site verification',
            intro: 'Proves to Google Search Console and Bing Webmaster Tools that this site is yours. Choose the HTML tag method there and paste the code, or the whole {tag} tag. It is added to every page; it sets no cookie, so it needs no consent.',
        },
        feed: {
            title: 'Merchant Center product feed',
            intro: 'Add a feed in Google Merchant Center (Products, Add products from a file, scheduled fetch) with the URL for each language you sell in. It lists every published product with a picture and a price, at the price the shop shows, with brand, barcode and shipping. Gift cards are left out.',
            moduleOff: 'The feed answers once the Google module is switched on.',
        },
        save: 'Save Google settings',
    },
    meta: {
        intro: 'Loaded on every page only after the visitor allows marketing cookies: PageView everywhere, Purchase on the thank-you page. With the access token, every paid order placed with marketing consent is also sent from the server (Conversions API), with the same event id, so Meta counts it once.',
        moduleOff: 'It runs once the Meta Pixel module is switched on.',
        pixelId: 'Pixel ID',
        token: 'Conversions API access token',
        tokenPlaceholder: 'From Events Manager, Settings, Conversions API',
        removeToken: 'Remove the stored token',
        testCode: 'Test event code',
        testCodeNote: "While set, server events go to Events Manager's Test events tab only. Clear it to go live.",
        sendTest: 'Send test event',
        testReceived: 'Meta received no test events. | Meta received {n} test event. It shows in Events Manager under Test events. | Meta received {n} test events. They show in Events Manager under Test events.',
        save: 'Save Meta settings',
    },
};
